<template>
    <div class="converter-overlay">
        <div class="converter-overlay__content">
            <div>
                <slot />
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>
.converter-overlay {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
}

.converter-overlay__content {
    position: sticky;
    display: flex;
    justify-content: center;
    max-height: 100vh;
    height: 100%;
    width: 100%;
    top: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/Overlay.vue